import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { GIMonitor } from '../models/gimonitor';

@Injectable({
  providedIn: 'root'
})
export class MonitorService {

  constructor(private http: HttpClient) {

  }

  consultar() {
    return this.http.get<GIMonitor[]>(globals.apiUrl + '/api/Monitor/Listar');
  }

  consultarPorMonitor(monitor: number) {
    return this.http.get<any>(globals.apiUrl + '/api/Monitor/Buscar',
      { params: new HttpParams().set('monitor', monitor.toString()) });
  }

  salvar(monitor: GIMonitor) {
    return this.http.post(globals.apiUrl + '/api/Monitor/Salvar', monitor,
      { responseType: 'text' });
  }
}
